import type { PostAnalyticsBulkEventsEndpoint } from '@Common/types/bo_external/analytics/bulk_events';

import { getCurrentScreen } from '@sh4res/bo-common/utils/current_screen';
import { getDeviceId } from '@sh4res/bo-common/utils/device_id';

import { getApiUrl } from '@Utils/apiOrigin';

const ANALYTICS_ENDPOINT = '/analytics/bulk_events';

/**
 * Posts a batch of events.
 *
 * Deliberately uses `fetch` rather than the react-admin `httpClient`: that client is the one
 * we instrument for api-response events, so going through it would make every upload emit a
 * new event and never converge.
 *
 * @param body Batch to upload
 * @param keepalive Let the browser finish the request after the page goes away
 * @returns Whether the batch was accepted by the backend
 */
export const submitAnalyticsEvents = async (
  body: PostAnalyticsBulkEventsEndpoint['Client']['RequestBody'],
  keepalive = false,
): Promise<boolean> => {
  try {
    const response = await fetch(`${getApiUrl()}${ANALYTICS_ENDPOINT}`, {
      method: 'POST',
      credentials: 'include',
      keepalive,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        deviceid: getDeviceId(),
        'bo-current-screen': getCurrentScreen(),
        ...('version_sha' in window ? { 'bo-version': window.version_sha as string } : {}),
      },
      body: JSON.stringify(body),
    });

    return response.ok;
  } catch {
    return false;
  }
};
